export function isClientSide() {
  return typeof window !== 'undefined';
}

export function isServerSide() {
  return !isClientSide();
}



// WEBPACK FOOTER //
// ./app/utils/isomorphic.js